import { createSelector } from "@reduxjs/toolkit"
import { Address, getAddress } from "viem"

export const mapBalances = createSelector(
  [
    (assets: Address[]) => assets,
    (_, balances?: readonly bigint[]) => balances,
  ],
  (assets, balances) => {
    const data = new Map<Address, bigint>()
    assets.forEach((asset, i) => {
      if (balances && balances[i] !== undefined) {
        data.set(getAddress(asset), balances[i])
      }
    })

    return data
  },
)
